import React from "react";
import styled from "styled-components";

import { CardWrapper } from "./CardWrapper";
import { ItemList } from "./ItemList";
import { NewItemForm } from "./NewItemForm";
import { NewItemListHeader } from "./NewItemListHeader";
import { NewItemListFooter } from "./NewItemListFooter";

export const NewItemCard = ({
  list,
  items,
  markItem,
  deleteItem,
  saveItem,
  setList,
  baseList,
  handleAddressChange,
  handleAddressSearch,
  handleAddressSelect,
  address,
  addressList,
  calendarChange,
  calendarValue,
  saveListToDb
}) => {
  return (
    <CardWrapper>
      <form onSubmit={saveListToDb}>
        <NewItemListHeader
          handleAddressChange={handleAddressChange}
          handleAddressSearch={handleAddressSearch}
          address={address}
          addressList={addressList}
          handleAddressSelect={handleAddressSelect}
          calendarChange={calendarChange}
          calendarValue={calendarValue}
        />
        <Hr />
        <ItemList items={items} markItem={markItem} deleteItem={deleteItem} />
        <NewItemForm saveItem={saveItem} />
        <Hr />
        <NewItemListFooter setList={setList} baseList={baseList} />
      </form>
    </CardWrapper>
  );
};

const Hr = styled.hr`
  margin: 20px 0px;
`;
